<ng-container>
    <cmps-wait-status
        *ngIf="hasPendingData === true"
        class="p-2"
    ></cmps-wait-status>
    <div
        class="text-center p-3"
        *ngIf="failLoad"
    >
        {{ failLoad }}
    </div>
    <table
        *ngIf="hasPendingData === false && data"
        class="observations-tab-sec"
    >
        <thead>
            <tr>
                <th (click)="sortByField(0)">
                    <div>{{ i18n._7310_SESSION_DATE | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[0].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th
                    (click)="sortByField(1)"
                    class="limit-width"
                >
                    <div>{{ i18n._7309_SESSION_TYPE | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[1].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th
                    (click)="sortByField(2)"
                    class="limit-width"
                >
                    <div>{{ i18n._7347_OBSERVER | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[2].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(3)">
                    <div>{{ i18n._127_STATUS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[3].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(4)">
                    <div>{{ i18n._7348___OF_ASSOCIATIONS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[4].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th>
                    <div>{{ i18n._7349_INTERACTION_TYPE | translate }}</div>
                </th>
                <th>
                    <div>{{ i18n._7350_INTERACTION_DATE | translate }}</div>
                </th>
                <th *ngIf="!displayEvaluations">
                    <div>{{ i18n._7315___OF_EVALUATIONS | translate }}</div>
                </th>
                <ng-container *ngIf="displayEvaluations">
                    <th class="limit-width observations-history-metricname">
                        <div>{{ i18n._7351_FOCUS_EVALUATED | translate }}</div>
                        <div
                            class="cmps-cdk-cursor-pointer legacy:cmps-cdk-bg-color-green-100 cmps-cdk-border-radius-3px cmps-cdk-p-0dot25"
                            [title]="i18n._7352_HIDE_EVALUATIONS | translate"
                            tabindex="-1"
                            role="button"
                            (click)="hideSubs()"
                        >
                            <cmps-icon
                                class="cmps-cdk-fill-white"
                                svgIcon="arrow-collapse"
                            ></cmps-icon>
                        </div>
                    </th>
                    <th>{{ i18n._7353_EFFORT_DEMONSTRATED | translate }}</th>
                    <th>{{ i18n._7317_PROFICIENCY | translate }}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container
                *ngFor="let o of displayData | slice: 0 : displayRecords"
            >
                <tr [hidden]="!o.display">
                    <td
                        [rowSpan]="
                            displayEvaluations ? o.subRowSpan : o.rowSpan
                        "
                    >
                        <a (click)="iframe('Observation', o.coachingEventId)">
                            {{ o.sessionDate | date: 'MM/dd/y' }}
                        </a>
                    </td>
                    <td
                        [rowSpan]="
                            displayEvaluations ? o.subRowSpan : o.rowSpan
                        "
                    >
                        {{ o.sessionTypeName }}
                    </td>
                    <td
                        [rowSpan]="
                            displayEvaluations ? o.subRowSpan : o.rowSpan
                        "
                    >
                        {{ o.observerName }}
                    </td>
                    <td
                        [rowSpan]="
                            displayEvaluations ? o.subRowSpan : o.rowSpan
                        "
                    >
                        {{ o.statusName }}
                    </td>
                    <td
                        [rowSpan]="
                            displayEvaluations ? o.subRowSpan : o.rowSpan
                        "
                    >
                        {{ o.commitmentCount }}
                    </td>

                    <ng-container
                        *ngIf="
                            o.interactions && o.interactions.length;
                            else zeroInteractions
                        "
                    >
                        <td
                            [rowSpan]="
                                displayEvaluations
                                    ? o.interactions[0].subRowSpan
                                    : o.interactions[0].rowSpan
                            "
                        >
                            {{ o.interactions[0].interactionTypeName }}
                        </td>
                        <td
                            [rowSpan]="
                                displayEvaluations
                                    ? o.interactions[0].subRowSpan
                                    : o.interactions[0].rowSpan
                            "
                        >
                            {{
                                o.interactions[0].interactionDateTime
                                    | date: 'MM/dd/y'
                            }}
                        </td>
                        <td
                            [rowSpan]="
                                displayEvaluations
                                    ? o.interactions[0].subRowSpan
                                    : o.interactions[0].rowSpan
                            "
                            *ngIf="!displayEvaluations"
                        >
                            <a
                                (click)="showSubs()"
                                title="{{
                                    i18n._7354_SHOW_EVALUATIONS | translate
                                }}"
                                >{{
                                    o.interactions[0].evaluations
                                        ? o.interactions[0].evaluations.length
                                        : '0'
                                }}</a
                            >
                        </td>
                    </ng-container>
                    <ng-template #zeroInteractions>
                        <td></td>
                        <td></td>
                        <td></td>
                    </ng-template>

                    <ng-container *ngIf="displayEvaluations">
                        <ng-container
                            *ngIf="
                                o.interactions.length &&
                                    o.interactions[0].evaluations &&
                                    o.interactions[0].evaluations.length;
                                else noEv
                            "
                        >
                            <td>
                                {{ o.interactions[0].evaluations[0].focus }}
                            </td>
                            <td>
                                {{
                                    o.interactions[0].evaluations[0]
                                        .effortDemonstrated
                                }}
                            </td>
                            <td>
                                {{
                                    o.interactions[0].evaluations[0]
                                        .effortDemonstrated == 'Yes'
                                        ? o.interactions[0].evaluations[0]
                                              .proficiency
                                        : '-'
                                }}
                            </td>
                        </ng-container>
                        <ng-template #noEv>
                            <td></td>
                            <td></td>
                            <td></td>
                        </ng-template>
                    </ng-container>
                </tr>

                <!-- more evaluations for the first interaction -->
                <ng-container
                    *ngIf="
                        displayEvaluations &&
                        o.interactions &&
                        o.interactions.length
                    "
                >
                    <ng-container
                        *ngIf="
                            o.interactions[0] &&
                            o.interactions[0].evaluations &&
                            o.interactions[0].evaluations.length > 1
                        "
                    >
                        <tr
                            *ngFor="
                                let e of o.interactions[0].evaluations
                                    | slice: 1
                            "
                        >
                            <td>{{ e.focus }}</td>
                            <td>{{ e.effortDemonstrated }}</td>
                            <td>
                                {{
                                    e.effortDemonstrated == 'Yes'
                                        ? e.proficiency
                                        : '-'
                                }}
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>

                <!-- more interactions -->
                <ng-container
                    *ngIf="o.interactions && o.interactions.length > 1"
                >
                    <ng-container *ngFor="let i of o.interactions | slice: 1">
                        <tr>
                            <td
                                [rowSpan]="
                                    displayEvaluations
                                        ? i.subRowSpan
                                        : i.rowSpan
                                "
                            >
                                {{ i.interactionTypeName }}
                            </td>
                            <td
                                [rowSpan]="
                                    displayEvaluations
                                        ? i.subRowSpan
                                        : i.rowSpan
                                "
                            >
                                {{ i.interactionDateTime | date: 'MM/dd/y' }}
                            </td>
                            <td
                                [rowSpan]="
                                    displayEvaluations
                                        ? i.subRowSpan
                                        : i.rowSpan
                                "
                                *ngIf="!displayEvaluations"
                            >
                                <a
                                    (click)="showSubs()"
                                    title="Show Evaluations"
                                    >{{
                                        i.evaluations
                                            ? i.evaluations.length
                                            : '0'
                                    }}</a
                                >
                            </td>
                            <ng-container *ngIf="displayEvaluations">
                                <ng-container *ngIf="i.evaluations; else noEva">
                                    <td>{{ i.evaluations[0].focus }}</td>
                                    <td>
                                        {{
                                            i.evaluations[0].effortDemonstrated
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            i.evaluations[0]
                                                .effortDemonstrated == 'Yes'
                                                ? i.evaluations[0].proficiency
                                                : '-'
                                        }}
                                    </td>
                                </ng-container>
                                <ng-template #noEva>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </ng-template>
                            </ng-container>
                        </tr>
                        <!-- more evaluations -->
                        <ng-container *ngIf="displayEvaluations">
                            <ng-container
                                *ngIf="
                                    i.evaluations && i.evaluations.length > 1
                                "
                            >
                                <tr *ngFor="let e of i.evaluations | slice: 1">
                                    <td>{{ e.focus }}</td>
                                    <td>{{ e.effortDemonstrated }}</td>
                                    <td>
                                        {{
                                            e.effortDemonstrated == 'Yes'
                                                ? e.proficiency
                                                : '-'
                                        }}
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="allRecordsHidden || !data || !data.length">
                <tr>
                    <td [colSpan]="displayGoals ? 14 : 16">
                        {{ i18n._7323_NO_RESULTS_ | translate }}
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</ng-container>
